import React, {useEffect} from 'react';
import {RecognitionForm} from '../../components/RecognitionForm/RecognitionForm';
import {RecentRecognition} from '../../components/RecentRecognition/RecentRecognition';
import {useUserProfile} from "../../hooks/useUserProfile";

const HomePage = () => {

    // Sync user profile
    const {syncUserProfile, isAuthenticated} = useUserProfile();

    //Only sync after user is authenticated
    useEffect(() => {
        if (isAuthenticated) {
            syncUserProfile();
        }
    }, [isAuthenticated]);
    return (
        <div className="max-w-5xl mx-auto px-4">
            <div className='mt-4 md:mt-8'>
                <RecognitionForm/>
            </div>

            {/* A horizontal line to separate sections */}
            <div className="mt-9 mb-2 border-t border-gray-200"></div>

            <RecentRecognition/>
        </div>
    );
};

export default HomePage;